export const validateName = (name) => {
  if (name.length !== 0) {
    const nameRegex = /^[A-Za-z\s]+$/
    return nameRegex.test(name)
  }
  return false
}

export const validatePhoneNumber = (phoneNumber) => {
  if (phoneNumber.length !== 0) {
    const phoneNumberRegex = /^\d{10}$/
    return phoneNumberRegex.test(phoneNumber)
  }
  return false
}

export const validateEmail = (email) => {
  if (email.length !== 0) {
    const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/
    return emailRegex.test(email)
  }
  return false
}
